/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbBreakpointsMedium = '768px'
export const SbBreakpointsLarge = '1024px'
export const SbBreakpointsXlarge = '1270px'
